import { inject, Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: "root",
})
export class SnackbarService {
  translate = inject(TranslateService);

  constructor(private snackbar: MatSnackBar) {}

  openSnackbar(
    { message, action, duration }: any,
    options?: MatSnackBarConfig,
  ) {
    this.translate
      .get([message, action || "Dismiss"])
      .subscribe((translated) => {
        this.snackbar.open(
          translated[message],
          translated[action || "Dismiss"],
          {
            duration: duration || 5000,
            ...options,
          },
        );
      });
  }
}
